import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loginUser, setPermissions, setSelectedRole, setImpersonationEnabled } from '@store/reducers/auth';
import { Button } from '@components';
import { setWindowClass } from '@app/utils/helpers';
import { getCompactPermissionByRoleId } from '@app/services/permission';
import { selectRole } from '@app/services/auth';
import jwtDecode from 'jwt-decode';

const ChooseRole = () => {
	const isMounted = useRef(true);
	useEffect(() => { return () => { isMounted.current = false; }; }, []);
	const [isAuthLoading, setAuthLoading] = useState(false);
	const currentUser = useSelector((state: any) => state.auth.currentUser);

	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
        if(currentUser?.roles.length == 0){
			navigate('/login');
		}
    }, []);

	const handleSubmit = async(role) => {
		try {
			setAuthLoading(true);

			// Step 1: select role → get new token
			const selectResp = await selectRole(role.id);
			if (selectResp?.success !== true) {
				setAuthLoading(false);
				toast.error(selectResp?.message || 'Failed to select role');
				return;
			}
			dispatch(loginUser(selectResp.token));
			const decoded: any = jwtDecode(selectResp.token);
			dispatch(setImpersonationEnabled(decoded.impersonation_enabled ?? false));

			// Step 2: get permissions directly (no JWT decode)
			const permResp = await getCompactPermissionByRoleId(role.id);
			dispatch(setSelectedRole(role));
			dispatch(setPermissions(permResp?.success === true ? (permResp.collections || {}) : {}));
			if (permResp?.success === true) toast.success('Logged in successfully');
			if (isMounted.current) setAuthLoading(false);
			navigate('/');
        } catch (error: any) {
			setAuthLoading(false);
            toast.error(error?.message || 'Something went wrong');
        }
	}

	setWindowClass('hold-transition login-page');

	return (
		<div className="login-box">
			<div className="card card-outline card-primary">
				<div className="card-header text-center">
					<div className="h1">
						<span>Welcome {currentUser.first_name }!</span>
					</div>
				</div>
				<div className="card-body">
					<p className="login-box-msg">Please select the appropriate role that you would like to log in with!</p>
					<div className="row">
						{currentUser.roles && currentUser.roles.map((role) => (
						<div className="col-6" key={role.id}>
							<Button
								block
								className='mt-3'
								type="button"
								isLoading={isAuthLoading}
								onClick={() => handleSubmit(role)}
							>
								{ role.name }
							</Button>
						</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ChooseRole;
